import { isProductAnalyticsEnabled } from "@lucien-ai/ts";
import posthog from "posthog-js";

const key = process.env.NEXT_PUBLIC_POSTHOG_KEY?.trim() ?? "";
// Same gate as MixpanelInit: production build or NEXT_PUBLIC_PRODUCT_ANALYTICS_ENABLED.
const enabled = isProductAnalyticsEnabled({
  isProduction: process.env.NODE_ENV === "production",
  override: process.env.NEXT_PUBLIC_PRODUCT_ANALYTICS_ENABLED,
});

if (enabled && key) {
  posthog.init(key, {
    api_host: "/wisdom",
    // api_host: "https://eu.i.posthog.com",
    ui_host: "https://eu.posthog.com",
    defaults: "2025-05-24",
    capture_exceptions: true, // This enables capturing exceptions using Error Tracking, set to false if you don't want this
    debug: process.env.NODE_ENV !== "production",
    person_profiles: "always",
  });
}
